import SessionModalReducer from "@common/redux/reducers/SessionModalReducer";
import BaseAction from "@common/redux/actions/BaseAction";

class SessionModalAction extends BaseAction {
  onClose = async (linked) => {};

  open = async (onClose) => {
    this.dispatch({ open: true });
    this.onClose = onClose;
  };
}

const action = new SessionModalAction(SessionModalReducer);

export default action;
